import {shortenEnv} from "../../../Const";

export const DATA_HUB_DATA_API_BUCKET_NAME = `${shortenEnv}-data-hub-data-api`

export const dataHubApiConsts = {
    API_NAME: "data-hub-data-api", // This name needs to be the same as the name of the API in the App.tsx file
    DATABASE_NAME: `${shortenEnv}-data-hub`,
    API_PATH: {
        TABLE_DEFINITION: "/table/definition",
        COLUMN_METADATA: "/table/column-metadata",
        COLUM_ORDER: "/table/column-order",
        TABLE_DATA: "/table/data",
        LARGE_TABLE_DATA: "/large-table/data"
    },
}